// extracted by mini-css-extract-plugin
export var parcelRow = "_tz-0";